import {
  LOCATION_CLICK,
  LOCATION_SWIPE_LEFT,
  LOCATION_SWIPE_RIGHT,
  LOCATION_DETAIL_SWIPE_UP,
  SET_ACTIVE_LOCATION,
  TOGGLE_MAP_VIEW,
  CLOSE_ZOOM
} from "../data/constants";

const initialState = {
  data: {
    values: [
      {
        id: "d1",
        name: "الانتاجية",
        value: 75,
        history: [
          {
            date: "1-May-12",
            close: 10
          },
          {
            date: "30-Apr-12",
            close: 40
          },
          {
            date: "27-Apr-12",
            close: 60
          },
          {
            date: "26-Apr-12",
            close: 90
          }
        ]
      },
      {
        id: "d2",
        name: "القدرة الاستيعابية",
        value: 70,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 60
          }
        ]
      },
      {
        id: "d3",
        name: "مستوى الثقة ",
        value: 0,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d4",
        name: " نسبة الإشغال",
        value: 45,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d5",
        name: "استمرارية الخدمة",
        value: 80,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d6",
        name: "زمن الانتظار",
        value: 75,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d7",
        name: "زمن التقديم",
        value: 100,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d8",
        name: "زمن إنجاز الخدمة",
        value: 55,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d9",
        name: "زمن اتمام الخدمة",
        value: 35,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d10",
        name: "زمن الخدمة القياسي",
        value: 65,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d11",
        name: "مستوى سعادة المتعاملين",
        value: 85,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d12",
        name: "معدل جودة الخدمة الكلي",
        value: 15,
        history: [
          {
            date: "1-May-12",
            close: 90
          },
          {
            date: "30-Apr-12",
            close: 60
          },
          {
            date: "27-Apr-12",
            close: 40
          },
          {
            date: "26-Apr-12",
            close: 0
          }
        ]
      },
      {
        id: "d13",
        name: "تكلفة الوحدة من الخدمة",
        value: 60,
        history: [
          {
            date: "1-May-12",
            close: 0
          },
          {
            date: "30-Apr-12",
            close: 30
          },
          {
            date: "27-Apr-12",
            close: 70
          },
          {
            date: "26-Apr-12",
            close: 30
          },
          {
            date: "10-Mar-12",
            close: 90
          }
        ]
      }
    ],
    itemName: "متوسط اداء الخدمات للجهة الحكومية",
    icon: "\uf271",
    nextItem: { name: "الكيان", icon: "\uf1ec" },
    prevItem: { name: "الكيان", icon: "\uf786" }
  },
  isSwipedUp: false,
  isZoomed: false,
  activeLocation: null,
  view: "MAP",
  isZoomed: false,

  serviceCenterLocations: [
    { "id": 9, "name": "\u0645\u062d\u0627\u0643\u0645 \u062f\u0628\u064a", "lat": 24.954663, "lng": 55.02434, "measures_happiness_meter": 94, "entity": "\u0645\u0631\u0643\u0632 \u062e\u062f\u0645\u0629" },
    { "id": 13, "name": "\u062c\u0645\u0627\u0631\u0643 \u062f\u0628\u064a", "lng": 55.142392, "lat": 25.123877, "measures_happiness_meter": 97.4, "entity": "\u0645\u0631\u0643\u0632 \u062e\u062f\u0645\u0629" },
    { "id": 16, "name": "\u0647\u064a\u0626\u0629 \u0627\u0644\u0635\u062d\u0629 \u0628\u062f\u0628\u064a", "lat": 25.050497, "lng": 55.168473, "measures_happiness_meter": 61, "entity": "\u0642\u0646\u0627\u0629 \u062a\u0642\u062f\u064a\u0645 \u062e\u062f\u0645\u0629 \u0645\u062a\u062e\u0635\u0635\u0629" },
    { "id": 29, "name": "\u0645\u062d\u0627\u0643\u0645 \u062f\u0628\u064a", "lat": 24.969603, "lng": 55.102584, "measures_happiness_meter": 35, "entity": "\u0645\u0631\u0643\u0632 \u062e\u062f\u0645\u0629" },
    { "id": 23, "name": "\u062c\u0645\u0627\u0631\u0643 \u062f\u0628\u064a", "lng": 55.139646, "lat": 24.924777, "measures_happiness_meter": 75.4, "entity": "\u0645\u0631\u0643\u0632 \u062e\u062f\u0645\u0629" },
    { "id": 26, "name": "\u0647\u064a\u0626\u0629 \u0627\u0644\u0635\u062d\u0629 \u0628\u062f\u0628\u064a", "lat": 25.033836, "lng": 55.054063, "measures_happiness_meter": 41, "entity": "\u0642\u0646\u0627\u0629 \u062a\u0642\u062f\u064a\u0645 \u062e\u062f\u0645\u0629 \u0645\u062a\u062e\u0635\u0635\u0629" }
  ],

  cardNo: 0,
  counts: [0, 1, 2, 1, 2],
  totalCount: 6,
  verticalGraphData: [
    { name: "a", value: 74, selected: false },
    { name: "b", value: 64, selected: true },
    { name: "c", value: 54, selected: false },
    { name: "d", value: 44, selected: false },
    { name: "e", value: 34, selected: false },
    { name: "f", value: 24, selected: false },
    { name: "g", value: 43, selected: false },
    { name: "h", value: 4, selected: false },
    { name: "i", value: 94, selected: false },
    { name: "j", value: 84, selected: false },
    { name: "k", value: 90, selected: false },
    { name: "l", value: 95, selected: false },
    { name: "m", value: 40, selected: false },
    { name: "n", value: 66, selected: false },
    { name: "o", value: 85, selected: false },
    { name: "p", value: 56, selected: false },
    { name: "q", value: 69, selected: false }
  ],
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOCATION_CLICK:
      return {
        ...state,
        activeLocation: payload,
        isZoomed: !state.isZoomed
      };

    case LOCATION_SWIPE_LEFT:
      return {
        ...state,
        cardNo: state.cardNo + 1
      };
    case LOCATION_SWIPE_RIGHT:
      return {
        ...state,
        cardNo: state.cardNo - 1
      };

    case SET_ACTIVE_LOCATION:
      return {
        ...state,
        activeLocation: payload
      };

    case LOCATION_DETAIL_SWIPE_UP:
      return {
        ...state,
        isSwipedUp: payload === "Up"
      };
    case TOGGLE_MAP_VIEW:
      return {
        ...state,
        view: payload
      };
    case CLOSE_ZOOM:
      return {
        ...state,
        activeLocation: null,
        isZoomed: false
      };
    default:
      return state;
  }
};
